import React from 'react';

const ProjectCard = ({ project }) => {
  return (
    <a
      href={project.link}
      target="_blank"
      rel="noopener noreferrer"
      className="project-card"
    >
      <div className="project-card__img-wrap">
        <img src={project.image} alt={project.title} className="project-card__img" loading="lazy" />
      </div>
      <div className="project-card__body">
        <span className="project-card__kind">{project.kind}</span>
        <h3 className="project-card__title">
          {project.title}
          <span className="project-card__arrow" aria-hidden="true">↗</span>
        </h3>
        <p className="project-card__desc">{project.description}</p>
        <div className="project-card__tech">
          {project.technologies.map((tech) => (
            <span key={tech} className="chip chip--sm">
              {tech}
            </span>
          ))}
        </div>
      </div>
    </a>
  );
};

export default ProjectCard;
